import { infer as Infer, z } from 'zod';

import { phoneRegex } from '#utils/phone.regex';

export const userCreateSchema = z.object({
  name: z.string().min(1, 'Wpisz imię'),
  surname: z.string().min(1, 'Wpisz nazwisko'),
  email: z.email('Niepoprawny adres email').min(1, 'Email jest wymagany').toLowerCase().trim(),
  lvl: z.number(),
  phone: z.string().regex(phoneRegex, 'Niepoprawny numer telefonu').nullable(),
  birthdate: z
    .string()
    .nullable()
    .refine(
      (date) => {
        if (!date) return true;
        const birthDate = new Date(date);
        return birthDate < new Date();
      },
      { message: 'Data urodzenia musi być w przeszłości' }
    ),
  password: z.string().min(8, 'Hasło musi mieć co najmniej 8 znaków'),
  accountType: z.enum(['user', 'parent']).optional(),
});

export type UserCreateSchema = Infer<typeof userCreateSchema>;
